import { DotLegalCheckbox, DotLegalDeleteDialog } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import { useTranslation } from "../../../localization/useTranslation.ts";
import { useContractResponsibilityHelper } from "../ContractResponsibilityHelper.hooks.ts";
import { Trans } from "react-i18next";
import { ContractModel } from "../Contract.types.ts";
import { isNullOrWhitespace } from "@common/stringOperations.ts";

export interface VisibleToAllUsersFieldProps {
    contract: ContractModel | undefined;
    onChange: (changeFunc: (contract: ContractModel) => void) => Promise<void>;
    readOnly: boolean;
    isDisabled: boolean;
    errorText?: string;
    disableAccessWarning?: boolean;
}

function VisibleToAllUsersField(props: VisibleToAllUsersFieldProps) {
    const { translateString } = useTranslation();
    const { onFieldChange, handleDialogConfirm, pendingUserChanges, setPendingUserChanges } = useContractResponsibilityHelper(
        props.onChange,
        props.disableAccessWarning
    );

    return (
        <>
            <DotLegalCheckbox
                checked={props.contract?.visibleToAllUsers ?? false}
                label={translateString(props.contract?.hasAccessToMultipleGroupEntities ? "visibleToAllUsers" : "accessibleToAllUsers")}
                margin={{ marginLeft: -1.5 }}
                tooltip={translateString("visibleToAllUsersTooltip")}
                onChange={
                    props.readOnly
                        ? () => {}
                        : (value) => {
                              let newContract = { ...props.contract!, visibleToAllUsers: value };
                              onFieldChange(newContract, props.contract!);
                          }
                }
                disabled={props.isDisabled}
                error={!isNullOrWhitespace(props.errorText)}
                helperText={props.errorText}
            />

            {pendingUserChanges && (
                <DotLegalDeleteDialog
                    open
                    headerText={translateString("confirmAccessRemoval")}
                    alertBodyText={
                        <Trans
                            i18nKey="confirmContractAccessRemovalBody"
                            components={{
                                ul: <ul />,
                                li: <li />,
                            }}
                        />
                    }
                    warningTranslation={translateString("warning")}
                    deleteBtnText={translateString("save")}
                    cancelBtnText={translateString("cancel")}
                    onDialogClose={() => setPendingUserChanges(null)}
                    onOkClick={() => handleDialogConfirm()}
                />
            )}
        </>
    );
}

export default VisibleToAllUsersField;
